export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Audio Extractor",
  "Extract sound from videos with ease.": "Ton aus Videos mühelos extrahieren.",
  "Select Audio Format": "Audioformat auswählen",
  "Extract Audio": "Audio extrahieren",
  "Extracting Audio": "Audio extrahieren",
  "Extracted Successfully": "Erfolgreich extrahiert",
  "Extract New": "Neu extrahieren",
  "Extraction Failed": "Extraktion ist fehlgeschlagen",
  "Format": "Format",
};
